// extracted by mini-css-extract-plugin
export var buttonContent = "_2z-0";
export var centered = "_2z-1";
export var centeredFlex = "_2z-2";
export var errorText = "_2z-3";
export var icon = "_2z-4";
export var iconButtonContent = "_2z-5";
export var monospace = "_2z-6";
export var padded = "_2z-7";